/** InsCoder 2025-02-09 B + Mobile carousel dots: scroll-sync and click-to-scroll **/
(function () {
  function initCarouselDots() {
    var containers = document.querySelectorAll('[id^="CustStoreFeatureCarousel-"]');
    containers.forEach(function (container) {
      var sectionId = container.id.replace('CustStoreFeatureCarousel-', '');
      var section = document.getElementById('shopify-section-' + sectionId);
      if (!section) return;
      var dotsWrap = section.querySelector('.cust-store-feature__dots-list');
      if (!dotsWrap) return;
      var dots = dotsWrap.querySelectorAll('.flickity-page-dot');
      var items = container.querySelectorAll('.collage__item');
      if (!dots.length || !items.length || dots.length !== items.length) return;

      function getScrollParentPaddingStart() {
        var style = window.getComputedStyle(container);
        var paddingLeft = style.getPropertyValue('padding-inline-start') || style.paddingLeft;
        return parseInt(paddingLeft, 10) || 0;
      }

      function updateActiveDot() {
        var scrollLeft = container.scrollLeft;
        var containerWidth = container.clientWidth;
        var paddingStart = getScrollParentPaddingStart();
        var center = scrollLeft + containerWidth / 2;
        var currentIndex = 0;
        var minDist = Infinity;
        items.forEach(function (item, index) {
          var left = item.offsetLeft;
          var mid = left + item.offsetWidth / 2;
          var dist = Math.abs(mid - center);
          if (dist < minDist) {
            minDist = dist;
            currentIndex = index;
          }
        });
        dots.forEach(function (dot, index) {
          dot.setAttribute('aria-current', index === currentIndex ? 'true' : 'false');
        });
      }

      function scrollToIndex(index) {
        var item = items[index];
        if (!item) return;
        var paddingStart = getScrollParentPaddingStart();
        var targetScroll = item.offsetLeft - paddingStart;
        container.scrollTo({
          left: targetScroll,
          behavior: 'smooth'
        });
      }

      var scrollTimeout;
      container.addEventListener('scroll', function () {
        if (scrollTimeout) window.cancelAnimationFrame(scrollTimeout);
        scrollTimeout = window.requestAnimationFrame(function () {
          updateActiveDot();
        });
      }, { passive: true });

      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          var index = parseInt(dot.getAttribute('data-index'), 10);
          scrollToIndex(index);
        });
      });

      updateActiveDot();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCarouselDots);
  } else {
    initCarouselDots();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e.detail.sectionId && document.querySelector('#CustStoreFeatureCarousel-' + e.detail.sectionId)) {
      initCarouselDots();
    }
  });
})();
/** InsCoder 2025-02-09 E + Mobile carousel dots: scroll-sync and click-to-scroll **/
